import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

/**
 * Directiva SkipLink
 *
 * Maneja la funcionalidad de "Saltar al contenido principal" de forma reutilizable.
 *
 * Uso:
 * <a appSkipLink [targetId]="'main-content'" class="skip-link">
 *   Saltar al contenido principal
 * </a>
 */
@Directive({
    selector: '[appSkipLinkDirective]',
})
export class SkipLinkDirectiveDirective implements OnInit {
    @Input() targetId: string = 'main-content';
    @Input() scrollBehavior: ScrollBehavior = 'smooth';

    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) {}

    ngOnInit(): void {
        // Asegurar que el elemento es accesible por teclado
        if (!this.el.nativeElement.hasAttribute('tabindex')) {
            this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '0');
        }
    }

    @HostListener('click', ['$event'])
    @HostListener('keydown.enter', ['$event'])
    @HostListener('keydown.space', ['$event'])
    onActivate(event: Event): void {
        event.preventDefault();
        this.skipToTarget();
    }

    private skipToTarget(): void {
        const targetElement = document.getElementById(this.targetId);

        if (!targetElement) {
            console.warn(`[SkipLinkDirective] No se encontró elemento con ID: ${this.targetId}`);
            return;
        }

        if (targetElement.getAttribute('tabindex') !== '0') {
            this.renderer.setAttribute(targetElement, 'tabindex', '-1');
        }

        targetElement.focus({ preventScroll: true });
        targetElement.scrollIntoView({ behavior: this.scrollBehavior, block: 'start' });
    }     
}
